/**
 * IframeEmptyValidator class is responsible for validating if an iframe model is empty.
 * It uses AngularJS's $injector to get the $translate service for localization.
 */
class IframeEmptyValidator {
    /**
     * Constructs an instance of IframeEmptyValidator.
     * @param {Object} $injector - The AngularJS injector service.
     * @param {Object} model - The model to be validated.
     */
    constructor($injector, model) {
        this.$injector = $injector;
        this.model = model;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.IFRAME';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazy-loads the $translate service from the AngularJS injector.
     * @returns {Object} The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model to check if its content is empty.
     * @param {Object} from - The source object triggering the validation.
     * @returns {Object} An object containing validation details.
     */
    validate(from) {
        let isError = this.model.isContentEmpty();

        // If the model is empty and has no parents, it is not considered an error.
        if (isError && this.model.getParents().length === 0) {
            isError = false;
        }

        return {
            'onSheetBlur':      false,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            isError,
            'status':           isError ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Gets the error message for the validation.
     * @returns {string} The translated error message.
     */
    getErrorMessage() {
        const questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if a forced validation check is set.
     * @returns {boolean} True if a forced check is set, otherwise false.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Gets the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'IframeEmptyValidator';
    }
}

export default IframeEmptyValidator;